<template>
  <b-modal id="view_address_modal" ref="view_address_modal" hide-footer no-close-on-esc no-close-on-backdrop>
    <div slot="modal-header" class="mh">
      <div id="mh-text">
        <h1>
          <i class="fas fa-map-marked-alt"></i>
          <span>Company Address</span>
        </h1>
        <p id="mh-info" v-if="notEmptyObject(address)">
          <span v-if="'address_log_by' in address"
                style="font-size: 0.65rem;">Last Updated : {{ address.address_log_by.first_name }} {{ address.address_log_by.surname }} on {{
              address.updated_at | formatDateTime
            }}</span>
        </p>
      </div>
      <button id="mh-close" class="btn-close" v-on:click="hideModal()"><i class="fas fa-times"></i></button>
    </div>

    <div class="row">
      <div class="col-3"><strong>Company:</strong></div>
      <div v-if="notEmptyObject(address)" class="col-9">{{ address.belongs_to.company_name }}</div>
      <div class="col-3"><strong>Address Type:</strong></div>
      <div class="col-9" v-if="notEmptyObject(address)">{{ address.address_type.value }}</div>
      <div class="col-9" v-else></div>
      <div class="col-12">
        <hr class="mt-2 mb-2">
      </div>

      <div class="col-3"><strong>Building:</strong></div>
      <div class="col-9">{{ address.building }}</div>
      <div class="col-3"><strong>Street:</strong></div>
      <div class="col-9">{{ address.street }}</div>
      <div class="col-3"><strong>Locality:</strong></div>
      <div class="col-9">{{ address.locality }}</div>
      <div class="col-3"><strong>City/Town:</strong></div>
      <div class="col-9">{{ address.city_town }}</div>
      <div class="col-3"><strong>County:</strong></div>
      <div class="col-9">{{ address.county }}</div>
      <div class="col-3"><strong>Postcode:</strong></div>
      <div class="col-9">{{ address.postcode }}</div>
    </div>

    <div class="row mt-4" v-if="!$store.state.auth.me.roles.includes('client_sub') && !$store.state.auth.me.roles.includes('client_auth')">
      <div class="col-md-6">
        <button v-if="notEmptyObject(address) && (
        (($store.state.auth.me.roles.includes('admin') || $store.state.auth.me.roles.includes('manager')) ||
        ($store.state.auth.me.id === address.created_by.id  && this.can_delete))
        && address.address_type.value !== 'Registered Office' && address.address_type.value !== 'Head Office'
        )" class="btn orcaBtn danger" data-toggle="tooltip" title="Delete Address" @click.prevent="deleteAddress">
          Delete
        </button>
      </div>
      <div class="col-md-6" v-if="notEmptyObject(address)">
        <button class="btn orcaBtn greenBtn" data-toggle="tooltip" title="Edit Address" @click.prevent="editAddress">Edit</button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "view_address",
  data() {
    return {
      address: {}
    }
  },
  beforeMount() {
    axios.get(this.crmApiPath + 'contact_info/address/' + this.$store.state.addresses.id).then(address => this.address = address.data);
  },
  computed: {
    can_delete() {
      let address_created_add_10_minutes = this.$moment(this.address.created_at).utc().add(10, 'minutes');
      let can_delete = false;
      if (this.$moment().utc() < address_created_add_10_minutes) {
        can_delete = true;
      }
      return can_delete;
    }
  },
  methods: {
    hideModal() {
      this.$refs.view_address_modal.hide();
      this.$store.commit('HIDE_ADDRESS_MODALS');
    },
    deleteAddress() {
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Confirm Delete Address</div>' +
            '<div class="snotifyToast__body">' +
            'Are you sure that you wish to delete:<br>' + this.address.full_address +
            '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
            '</div>',
        buttons: [
          {
            text: 'Yes', action: (toast) => {
              this.$snotify.remove(toast.id);
              axios.delete(this.crmApiPath + 'contact_info/address/' + this.address.id, {
                params: {
                  // Set log values (current crm user)
                  belongs_to_type: 'App\\Models\\Companies\\Company',
                  belongs_to_id: this.address.belongs_to_id,
                  contact_info_model_type: 'App\\Models\\Contact_Info\\Address',
                  log_by_type: 'App\\Models\\Users\\User',
                  log_by_id: this.$store.state.auth.me.id
                }
              }).then(() => {
                this.$nextTick(() => {
                  this.$bus.$emit('logs::reload', {action: true});
                  this.$bus.$emit('address::reload', {action: true});
                  this.hideModal()
                });

              });
            }
          },
          {text: 'No', action: (toast) => this.$snotify.remove(toast.id)}
        ]
      });
    },
    editAddress() {
      this.$store.commit('SHOW_EDIT_ADDRESS_MODAL', {
        id: this.address.id,
        company_id: this.address.company_id,
        company_name: this.address.belongs_to.company_id,
        row_node_id: this.$store.state.addresses.current_row_id
      });
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'edit_address_modal'))
    }
  }
}
</script>
